import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { CREATE_DEFAULTS, FETCH_DEFAULTS } from 'ContentData/constants/apiDefaults';
import Routes from 'ContentUtils/Routes';
import { ACCEPTED_SOURCE_APPS } from 'ContentData/constants/workflows';
import { getPageOfAssetsOfTypesForDependencyNodeRpc } from '../../__generated__/chirp/com/hubspot/crm/usages/rpc/CrmUsagesServiceV3';
const MAX_PAGES = 50;

/**
 * GET automation/v3/workflows
 * NOTE: This endpoint is not paginated
 */
export const fetchWorkflows = (...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('automation/v3/workflows', Object.assign({}, FETCH_DEFAULTS.workflows));
};

/**
 * GET automation/v3/workflows/{id}
 */
export const fetchWorkflow = (id, ...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`automation/v3/workflows/${id}`);
};

/* POST GET automation/v3/workflows */
export const createWorkflow = (name, ...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.post('automation/v3/workflows', {
    data: Object.assign({}, CREATE_DEFAULTS.workflows, {
      name
    })
  });
};

/* POST automationplatform/v1/hybrid/ids/fetch */
export const fetchHybridWorkflowsBatch = (flowIds = [], ...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.post('automationplatform/v1/hybrid/ids/fetch', {
    data: flowIds
  });
};

/**
 * CHIRP: CrmUsagesServiceV3.getPageOfAssetsOfTypesForDependencyNode
 * Fetches all FLOW_ACTION assets (workflow dependencies) for a given form.
 * Handles pagination internally (capped at MAX_PAGES), returning a flat array.
 */
export const fetchFormWorkflowDependencies = (formId, formTypeId) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: http
  });
  const dependencyName = `${formTypeId}-${formId}`;
  const allResults = [];
  let currentOffset = {};
  let pageCount = 0;
  const fetchPage = () => {
    return rpcClient.call(getPageOfAssetsOfTypesForDependencyNodeRpc, {
      request: {
        dependencyType: 'FORM',
        dependencyName,
        assetTypes: ['FLOW_ACTION'],
        requestOptions: {
          includeMetadata: false
        },
        pageLength: 100,
        offset: currentOffset
      }
    }).then(response => {
      allResults.push(...response.results);
      pageCount++;
      if (response.hasMore && pageCount < MAX_PAGES) {
        currentOffset = response.offset;
        return fetchPage();
      }
      return allResults;
    });
  };
  return fetchPage();
};

/**
 * GET automationapps/v1/summaries
 */
export const fetchWorkflowSummaries = (query, ...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('automationapps/v1/summaries', {
    query: Object.assign({
      flowObjectType: 'CONTACT'
    }, query)
  });
};

/* POST automationplatform/v1/hybrid/batch */
export const updateWorkflowHybrid = (workflowHybrid, sourceApp = ACCEPTED_SOURCE_APPS.CMS_FORM_MODULE_FIELD, ...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.post('automationplatform/v1/hybrid/batch', {
    query: {
      sourceApp
    },
    data: workflowHybrid
  });
};

/* POST automationplatform/v1/hybrid/create */
export const createWorkflowHybrid = (workflowHybrid, contentId, sourceApp = ACCEPTED_SOURCE_APPS.CMS_FORM_MODULE_FIELD, ...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.post('automationplatform/v1/hybrid/create', {
    query: {
      sourceApp
    },
    data: workflowHybrid,
    headers: {
      'x-hs-referer': Routes.edit(contentId)
    }
  });
};

/* DELETE automationplatform/v1/hybrid/{flowId} */
export const deleteWorkflowHybrid = (flowId, sourceApp, ...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.delete(`automationplatform/v1/hybrid/${flowId}`, {
    query: {
      sourceApp
    }
  });
};

/* POST automationmanagement/v1/references */
export const fetchWorkflowReferences = (flowId, ...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.post('automationmanagement/v1/references', {
    data: {
      flowIds: [flowId],
      includeOutboundReferences: false
    }
  });
};